import { defineParams } from "@sveltejs/kit/params";
import { languages } from "./lib/lang.ts";

export const params = defineParams({
  locale: (param) => {
    if (!languages.some((l) => l.code.toLowerCase() === param.toLowerCase()))
      return;
    return param;
  },
});
